import { Link } from "react-router-dom";
import { useTranslate } from "../../../context/TranslationContext";
import Footer from "../../footer";

const TemplateLayout = (props) => {
  const { t } = useTranslate("courseLayout");
  const { children } = props;

  return (
    <>
      <section className="course-header pt-4">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="d-flex align-items-center gap-2 justify-content-between flex-wrap">
                <div className="d-flex align-items-center gap-3">
                  <Link className="navbar-brand" to={"/"}>
                    <img
                      src="../assets/images/logo.png"
                      alt=""
                      className="img-fluid site-logo"
                    />
                  </Link>
                </div>
                <Link
                  to="/"
                  className="white-text d-flex gap-2 align-items-center"
                >
                  <i className="fas fa-angle-left" />
                  <p className="mb-0">{t("backToHome")}</p>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {children}
      <Footer />
    </>
  );
};

export default TemplateLayout;
